const { digits } = require('./digits')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @returns {*}
 */
function thousands ({ value }) {
  if (!value) return
  return digits({ value })
}

module.exports = { thousands }
